import LanguageValueObj from "./LanguageValueObj";

export default class GenericLangValue extends LanguageValueObj {
  constructor(name, initialValue=[], namespace) {
    super(initialValue);
    this.namespace=namespace;
    this.name=name;
    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  parseInputJSON(inputJSON) {
    if (!inputJSON||!inputJSON[this.namespace]) {
      return;
    }
    super.parseInputJSON(inputJSON, this.namespace);
  }
}
